const state = {
  offlineNoticeShown: false,
  unstableNoticeShown: false,
};

export const shouldShowOfflineNotice = () => !state.offlineNoticeShown;

export const markOfflineNoticeShown = () => {
  state.offlineNoticeShown = true;
};

export const shouldShowUnstableNotice = () => !state.unstableNoticeShown;

export const markUnstableNoticeShown = () => {
  state.unstableNoticeShown = true;
};

export const resetUnstableNotice = () => {
  state.unstableNoticeShown = false;
};

export const resetOnConnectionRecovered = () => {
  state.offlineNoticeShown = false;
  state.unstableNoticeShown = false;
};
